module.exports = __webpack_public_path__ + "img/img-22.a409792b.png";